module.exports = __webpack_public_path__ + "img/logo.86d57a81.png";